export default "__VITE_ASSET__efeb7dbd__"